import Axios from "../api/axios";
import config from "../../config";

const getWpLetter = () => {
  return Axios.get(`${config.BASE_URL}wp-letter`);
};

export default getWpLetter;
